import EcoNavProduct, { EcoNavProductItemProps, EcoNavProductProps } from 'eco-design/sections/eco-nav-product';
import { useGlobal } from '@/utils/useGlobal';
import { FC, useState } from 'react';
import gtm from '@/utils/gtm';
import styles from './index.module.scss';

interface NavProps {
    theme?: 'black' | 'white';
}

enum TabsEnum {
    Overview = '/ocean-pro-home-solar-battery',
    FAQ = '/ocean-pro-home-solar-battery/faq',
}

const Nav: FC<NavProps> = (props) => {
    const { theme = 'black' } = props;
    const { useLang, useRouter } = useGlobal();
    const router = useRouter();
    const [defaultTabActiveKey, setDefaultTabActiveKey] = useState(router?.pathname || '');

    const { t } = useLang('PowerOcean');

    const dataA: EcoNavProductProps = {
        tabItems: [
            {
                value: TabsEnum.Overview,
                label: t(`nav_overview`),
            },
        ],
    };

    const handleTabChange = (item: EcoNavProductItemProps) => {
        switch (item.value) {
            case TabsEnum.Overview:
                if (defaultTabActiveKey === TabsEnum.FAQ) {
                    router.push(TabsEnum.Overview);
                } else {
                    window.scrollTo({
                        top: 0,
                        behavior: 'smooth',
                    });
                }
                break;
            case TabsEnum.FAQ:
                router.push(TabsEnum.FAQ);
                break;
        }
    };

    return (
        <div className={styles.comp}>
            <EcoNavProduct
                productItems={[
                    {
                        value: 'logo',
                        label: t(`nav_logo_text`),
                        href: '/products/powerocean',
                    },
                ]}
                {...dataA}
                defaultTabActiveKey={defaultTabActiveKey}
                theme={theme}
                onTabChange={handleTabChange}
                onBuyChange={(item) => {
                    gtm.push(item.dataLayer);
                }}
            />
        </div>
    );
};

export default Nav;
